export default __webpack_public_path__ + "static/media/person-1.25ecff26.png";